'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalizationManager = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _languages = require('./languages');

var languages = _interopRequireWildcard(_languages);

var _helpers = require('../helpers');

var _en = require('./en.json');

var _en2 = _interopRequireDefault(_en);

var _es = require('./es.json');

var _es2 = _interopRequireDefault(_es);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Manages the localization settings
 */
var LocalizationManager = exports.LocalizationManager = function () {
  /**
   * Constructor
   */
  function LocalizationManager() {
    (0, _classCallCheck3.default)(this, LocalizationManager);

    this.translations = {};
    this.translations[languages.ES] = _es2.default;
    this.translations[languages.EN] = _en2.default;
    this.supportedLanguages = (0, _keys2.default)(this.translations);
  }

  /**
   * extend the default language data
   * @returns {Object}
   */


  (0, _createClass3.default)(LocalizationManager, [{
    key: 'extend',
    value: function extend(_ref) {
      var spanishData = _ref.spanishData,
          englishData = _ref.englishData;

      this.translations[languages.ES] = (0, _extends3.default)({}, _es2.default, spanishData);
      this.translations[languages.EN] = (0, _extends3.default)({}, _en2.default, englishData);

      return this;
    }

    /**
     * set the language to be used
     * @param {string} language the language (es|en)
     */

  }, {
    key: 'setLanguage',
    value: function setLanguage(language) {
      this.language = language;
    }

    /**
     * Returns the current language
     * @returns {string}
     */

  }, {
    key: 'getCurrentLanguage',
    value: function getCurrentLanguage() {
      if (!(0, _helpers.exists)(this.language)) {
        this.language = languages.ES;
      }

      return this.language;
    }

    /**
     * Translate a given key using the current language
     * @param {string} key Text ID
     * @returns {string}
     */

  }, {
    key: 'get',
    value: function get(key) {
      return this.translations[this.getCurrentLanguage()][key] || key;
    }
  }]);
  return LocalizationManager;
}();

exports.default = new LocalizationManager();


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/utils/localization/LocalizationManager.js
// module id = 127
// module chunks = 35783957827783 71851226274881